import { render, staticRenderFns } from "./CartaoLiberar.vue?vue&type=template&id=2e3a4ddc&scoped=true"
import script from "./CartaoLiberar.vue?vue&type=script&lang=js"
export * from "./CartaoLiberar.vue?vue&type=script&lang=js"
import style0 from "./CartaoLiberar.vue?vue&type=style&index=0&id=2e3a4ddc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3a4ddc",
  null
  
)

export default component.exports